import { createAction } from '@reduxjs/toolkit';

import {
  DELETE_TABLE_FILTER,
  INC_TABLE_DATA_VERSION,
  REFRESH_TABLE,
  RESET_TABLE_FILTERS,
  RESET_TABLE_SEARCH,
  SET_HEADER_CUSTOMER_NAME,
  SET_ORDER_CREATE_DATE_LIMIT_FILTER,
  SET_TABLE_CHECKED_ITEMS_DATA,
  SET_TABLE_COLUMN_ORDERING,
  SET_TABLE_CONFIG_VIEWS,
  SET_TABLE_CUR_CHECKED_ITEMS_DATA,
  SET_TABLE_CURRENT_PAGE,
  SET_TABLE_FILTERS,
  SET_TABLE_META,
  SET_TABLE_ROWS_PER_PAGE,
  SET_TABLE_SCOPE,
  SET_TABLE_SEARCH,
  SET_WAS_UPDATED,
} from '../constants/actionTypes';

const setTableScope = (scope) => {
  const storageFilters = localStorage.getItem('filters');
  const storageConfigViews = localStorage.getItem('config-views');
  const storageSearch = localStorage.getItem('search');

  return {
    type: SET_TABLE_SCOPE,
    payload: {
      scope,
      filters: storageFilters ? JSON.parse(storageFilters) : {},
      configViews: storageConfigViews ? JSON.parse(storageConfigViews) : {},
      search: storageSearch ? JSON.parse(storageSearch) : {},
      checkedItems: [],
      currentPage: 1,
    },
  };
};

const refreshTable = (scope) => async (dispatch) => {
  await dispatch({ type: REFRESH_TABLE, payload: { scope: `${scope}_refreshing` } });
  dispatch({ type: REFRESH_TABLE, payload: { scope } });
};

const incTableDataVersion = (scope) => async (dispatch) => {
  dispatch({ type: INC_TABLE_DATA_VERSION, payload: { scope } });
};

const setOrderLimitFilter = (payload) => ({ type: SET_ORDER_CREATE_DATE_LIMIT_FILTER, payload });

const setFilters = (filters) => ({ type: SET_TABLE_FILTERS, payload: filters });

const deleteFilterAction = createAction(DELETE_TABLE_FILTER, (scope, filterName) => ({
  payload: { scope, filterName },
}));

const setSearch = (search) => {
  localStorage.setItem('search', JSON.stringify(search));

  return { type: SET_TABLE_SEARCH, payload: search };
};

const setConfigViews = (views) => {
  localStorage.setItem('config-views', JSON.stringify(views));

  return { type: SET_TABLE_CONFIG_VIEWS, payload: views };
};

const resetFilters = (scope) => {
  localStorage.setItem('filters', JSON.stringify({}));

  return { type: RESET_TABLE_FILTERS, payload: scope };
};

const resetSearch = () => {
  localStorage.setItem('search', JSON.stringify({}));

  return { type: RESET_TABLE_SEARCH, payload: { search: {} } };
};

const setCheckedItemsData = (checkedItemsData) => ({
  type: SET_TABLE_CHECKED_ITEMS_DATA,
  payload: { checkedItemsData },
});

const setCurCheckedItemsData = (curCheckedItemsData) => ({
  type: SET_TABLE_CUR_CHECKED_ITEMS_DATA,
  payload: { curCheckedItemsData },
});

const setHeaderCustomerName = (customerName) => ({
  type: SET_HEADER_CUSTOMER_NAME,
  payload: { customerName },
});

const setRowsPerPage = (rowsPerPage) => {
  localStorage.setItem('rowsPerPage', JSON.stringify(rowsPerPage));

  return { type: SET_TABLE_ROWS_PER_PAGE, payload: { rowsPerPage, currentPage: 1 } };
};

const setTableMetaAction = createAction(SET_TABLE_META);

const setCurrentPage = (currentPage) => ({
  type: SET_TABLE_CURRENT_PAGE,
  payload: { currentPage },
});

const setWasUpdated = () => ({ type: SET_WAS_UPDATED });

const setColumnOrdering = createAction(SET_TABLE_COLUMN_ORDERING, ({ scope, columnOrdering }) => {
  localStorage.setItem(`columnOrdering:${scope}`, JSON.stringify(columnOrdering));

  return {
    payload: {
      columnOrdering,
      scope,
    },
  };
});

export {
  setTableScope,
  refreshTable,
  setFilters,
  setSearch,
  resetFilters,
  resetSearch,
  setRowsPerPage,
  setCheckedItemsData,
  setHeaderCustomerName,
  setWasUpdated,
  setCurrentPage,
  setCurCheckedItemsData,
  deleteFilterAction,
  setTableMetaAction,
  setConfigViews,
  setColumnOrdering,
  setOrderLimitFilter,
  incTableDataVersion,
};
